import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAvailableTags,
  setFilter,
  clearFilters,
  selectAvailableTags,
  selectQuestionFilters,
} from "../../../redux/slices/question-bank-slice";
import ChipMultiSelect from "./ChipMultiSelect";

const TYPE_OPTIONS = [
  { value: "VIDEO", label: "Video" },
  { value: "MCQ", label: "MCQ" },
  { value: "BEHAVIORAL", label: "Behavioral" },
  { value: "SKILL", label: "Skill" },
  { value: "LIP_SYNC", label: "Lip-sync" },
  { value: "PRACTICE", label: "Practice" },
  { value: "CODING", label: "Coding" },
];

const DIFFICULTY_OPTIONS = [
  { value: "EASY", label: "Easy" },
  { value: "MEDIUM", label: "Medium" },
  { value: "HARD", label: "Hard" },
  { value: "EXPERT", label: "Expert" },
];

const LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "hi", label: "Hindi" },
  { value: "es", label: "Spanish" },
  { value: "fr", label: "French" },
];

export default function FilterRow() {
  const dispatch = useDispatch();
  const filters = useSelector(selectQuestionFilters);
  const availableTags = useSelector(selectAvailableTags);

  useEffect(() => {
    if (!availableTags.length) dispatch(fetchAvailableTags());
  }, [dispatch, availableTags.length]);

  const tagOptions = useMemo(
    () => (availableTags || []).map((t) => ({ value: t.tag, label: t.tag, count: t.count })),
    [availableTags],
  );

  const setKey = (key, value) => dispatch(setFilter({ key, value }));

  const hasAny =
    (filters.search && filters.search.length > 0) ||
    filters.types.length > 0 ||
    filters.difficulties.length > 0 ||
    filters.tags.length > 0 ||
    filters.languages.length > 0;

  return (
    <div style={row}>
      <input
        type="text"
        value={filters.search}
        onChange={(e) => setKey("search", e.target.value)}
        placeholder="Search question text…"
        style={searchInput}
      />
      <ChipMultiSelect
        label="Type"
        options={TYPE_OPTIONS}
        selected={filters.types}
        onChange={(v) => setKey("types", v)}
      />
      <ChipMultiSelect
        label="Difficulty"
        options={DIFFICULTY_OPTIONS}
        selected={filters.difficulties}
        onChange={(v) => setKey("difficulties", v)}
      />
      <ChipMultiSelect
        label="Tag"
        options={tagOptions}
        selected={filters.tags}
        onChange={(v) => setKey("tags", v)}
        emptyText="No tags used yet"
      />
      <ChipMultiSelect
        label="Language"
        options={LANGUAGE_OPTIONS}
        selected={filters.languages}
        onChange={(v) => setKey("languages", v)}
      />
      {hasAny && (
        <button onClick={() => dispatch(clearFilters())} style={clearBtn}>
          Clear
        </button>
      )}
    </div>
  );
}

const row = {
  display: "flex",
  gap: 6,
  alignItems: "center",
  marginBottom: 12,
  flexWrap: "wrap",
};
const searchInput = {
  flex: "1 1 240px",
  minWidth: 200,
  padding: "6px 10px",
  border: "1px solid #E2E8F0",
  borderRadius: 6,
  fontSize: 12,
  color: "#0F172A",
  outline: "none",
  background: "white",
};
const clearBtn = {
  padding: "6px 10px",
  borderRadius: 6,
  background: "none",
  color: "#7B5AC4",
  border: "none",
  fontWeight: 600,
  fontSize: 11,
  cursor: "pointer",
};
